import styled from "styled-components";
import { LoginCardContent, LoginContainer } from '../home/home.styles';
export const PaleGreenBg = styled(LoginContainer) `
  background: #f8fafc;
`;
export const CenteredCard = styled(LoginCardContent) `
  min-width: 480px;
  margin: 0 auto;
  box-shadow: 0 1px 3px 0 hsla(0, 0%, 0%, 0.1), 0 0 0 1px hsla(0, 0%, 0%, 0.07);
  background-color: hsla(0, 0%, 100%, 1);
  padding: calc(calc(5 * 1px) * 4)!important;
  box-shadow: 0 1px 3px 0 hsla(0, 0%, 0%, 0.1), 0 0 0 1px hsla(0, 0%, 0%, 0.07);
  border-radius: 15px;

  &:before{
    content: none;
  }
`;
export const LogoRow = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 18px;
`;
export const LogoImg = styled.img `
  height: 24px;
`;
export const Title = styled.h2 `
  font-size: 18px;
  font-weight: 600;
  color: hsla(0, 0%, 18%, 1);
  margin: 0;
  margin-bottom: 18px;
`;
export const OrgList = styled.div `
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 420px;
  overflow-y: auto;
  padding-right: 4px;
`;
export const OrgCard = styled.button `
  user-select: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  flex-direction: row;
  flex: 1;
  cursor: pointer;
  border-radius: 12px;
  background-color: hsla(0, 0%, 100%, 1);
  padding: calc(calc(5 * 1px) * 2);
  background-color: hsla(var(--ue-option-panel-background-color_h, 0), var(--ue-option-panel-background-color_s, 0%), calc(var(--ue-option-panel-background-color_l, 100%) - 9%), calc(var(--ue-option-panel-background-color_t, 1) - 0.1));
  box-sizing: border-box;
  border-block-end: none;
  outline: none;
  border: none;
  
  &:hover {
    box-shadow: inset 0 0 0 2px hsla(129, 60%, 50%, 1) !important;
  }
`;
export const OrgLeft = styled.div `
  display: flex;
  align-items: center;
  gap: 14px;
`;
export const OrgIcon = styled.div `
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  color: hsla(0, 0%, 33.33%, calc(1 - 0.15));
`;
export const OrgName = styled.span `
  font-size: 1.08rem;
  font-weight: 600;
  color: #222;
`;
export const OrgChevron = styled.div `
  color: #222;
  font-size: 1.3rem;
`;
